module.exports = __webpack_public_path__ + "static/img/son3_active.add64b21.png";